import React from 'react'
// circle must be updated or replaced on gradient implementation stage
// import Circle from 'app/components/SVGS/Circle'
import cn from 'classnames'

import { EColors } from 'app/constants/colors'
import './styles.scss'

const SQUARE_SIZE = 120
const STROKE_WIDTH = 5

const bc = 'user-avatar'

const UserAvatarWithStats = ({
  avatar,
  isRecentFeed,
  isLeaderBoard,
  initials,
  proTrackProgress,
  isProtrackPopup,
  isReactionPopup,
  isReactionBoard,
  showCircleProgress,
  isReactionPopupTagged,
  isMyStoriesPage,
}) => {
  // SVG centers the stroke width on the radius, subtract out so circle fits in square
  const radius = (SQUARE_SIZE - STROKE_WIDTH) / 2
  // Enclose cicle in a circumscribing square
  const viewBox = `0 0 ${SQUARE_SIZE} ${SQUARE_SIZE}`
  // Arc length at 100% coverage is the circle circumference
  const dashArray = radius * Math.PI * 2
  // Scale 100% coverage overlay with the actual percent
  const dashOffset = dashArray - (dashArray * proTrackProgress) / 100

  return (
    <div
      className={cn(bc, {
        [`${bc}__leader-board`]: isLeaderBoard,
        [`${bc}__recent-feed`]: isRecentFeed,
        [`${bc}__protrack-popup`]: isProtrackPopup,
        [`${bc}__reaction-popup`]: isReactionPopup,
        [`${bc}__reaction-board`]: isReactionBoard,
        [`${bc}__isMyStoriesPage`]: isMyStoriesPage,
      })}
    >
      {/* svg must be moved to separate component after gradient implementation */}
      {showCircleProgress && (
        <svg width={SQUARE_SIZE} height={SQUARE_SIZE} viewBox={viewBox}>
          <linearGradient id={'id2'} x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#087acb" />
            <stop offset="100%" stopColor={EColors.LIGHT_BLUE} />
          </linearGradient>
          <circle
            className={`${bc}__circle-background`}
            cx={SQUARE_SIZE / 2}
            cy={SQUARE_SIZE / 2}
            r={radius}
            strokeWidth={`${STROKE_WIDTH}px`}
          />
          <circle
            className={`${bc}__circle-progress`}
            stroke={`url(#id2)`}
            cx={SQUARE_SIZE / 2}
            cy={SQUARE_SIZE / 2}
            r={radius}
            strokeWidth={`${STROKE_WIDTH}px`}
            // Start progress marker at 12 O'Clock
            transform={`rotate(-90 ${SQUARE_SIZE / 2} ${SQUARE_SIZE / 2})`}
            style={{
              strokeDasharray: dashArray,
              strokeDashoffset: dashOffset,
            }}
          />
        </svg>
      )}
      <>
        {avatar ? (
          <div className={cn({ [`${bc}__with-circle`]: showCircleProgress })}>
            <img className={`${bc}__avatar-img`} src={avatar} alt={initials} />
          </div>
        ) : (
          <div
            className={cn(`${bc}__initials`, {
              [`${bc}__initials--recent-feed`]: isRecentFeed,
              [`${bc}__initials--leader-board`]: isLeaderBoard,
              [`${bc}__initials--protrack-popup`]: isProtrackPopup,
              [`${bc}__initials--reaction-popup`]: isReactionPopup,
              [`${bc}__initials--reaction-popup-tagged`]: isReactionPopupTagged,
              [`${bc}__initials--reaction-board`]: isReactionBoard,
              [`${bc}__initials--isMyStoriesPage`]: isMyStoriesPage,
            })}
          >
            {initials}
          </div>
        )}
      </>
    </div>
  )
}

export default UserAvatarWithStats
